import { Form, Checkbox, Row, Col } from 'antd';
import FloatingFormItem from '../../FloatingFormItem';
import InputDecimal from '../../InputDecimal';
import SectionCard from '../../SectionCard';

interface Props {
  prefixPath?: string[];
}

export default function CreditTransfersReversalFormFields({
  prefixPath = ['itemTaxes', 'ibsCbs'],
}: Props) {
  const form = Form.useFormInstance();
  const enableCreditTransfersReversal = Form.useWatch(
    'enableCreditTransfersReversal',
    form,
  );

  return (
    <>
      <div>
        <Form.Item name="enableCreditTransfersReversal" valuePropName="checked">
          <Checkbox style={{ fontWeight: 600 }}>
            Exibir Grupo Transferências/Estorno de Crédito
          </Checkbox>
        </Form.Item>
      </div>

      <div
        style={{ display: enableCreditTransfersReversal ? 'block' : 'none' }}
      >
        <SectionCard
          visible
          style={{ marginBottom: 24 }}
          title="Transferências de Crédito"
        >
          <Row gutter={[16, 16]}>
            <Col span={24} sm={12} md={6}>
              <FloatingFormItem
                label="Valor IBS a ser transferido"
                name={[...prefixPath, 'creditTransferIbsValue']}
              >
                <InputDecimal />
              </FloatingFormItem>
            </Col>

            <Col span={24} sm={12} md={6}>
              <FloatingFormItem
                label="Valor CBS a ser transferido"
                name={[...prefixPath, 'creditTransferCbsValue']}
              >
                <InputDecimal />
              </FloatingFormItem>
            </Col>
          </Row>
        </SectionCard>

        <SectionCard
          visible
          style={{ marginBottom: 24 }}
          title="Estorno de Crédito"
        >
          <Row gutter={[16, 16]}>
            <Col span={24} sm={12} md={6}>
              <FloatingFormItem
                label="Valor IBS a ser estornado"
                name={[...prefixPath, 'creditReversalIbsValue']}
              >
                <InputDecimal />
              </FloatingFormItem>
            </Col>

            <Col span={24} sm={12} md={6}>
              <FloatingFormItem
                label="Valor CBS a ser estornado"
                name={[...prefixPath, 'creditReversalCbsValue']}
              >
                <InputDecimal />
              </FloatingFormItem>
            </Col>
          </Row>
        </SectionCard>
      </div>
    </>
  );
}
